"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTargetChart = void 0;
const react_1 = require("react");
const _params_1 = require("@params");
const js_cookie_1 = __importDefault(require("js-cookie"));
const targetsInitState = [];
const initExerciseKey = "";
const useTargetChart = () => {
    const [targets, setTargets] = (0, react_1.useState)(targetsInitState);
    const [exerciseList, setExerciseList] = (0, react_1.useState)(null);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [isDataLoading, setDataLoading] = (0, react_1.useState)(false);
    const [exerciseKey, setExerciseKey] = (0, react_1.useState)(initExerciseKey);
    const selectExercise = (0, react_1.useCallback)((key) => {
        setExerciseKey(key);
    }, [setExerciseKey]);
    const resetExerciseKey = (0, react_1.useCallback)(() => {
        setExerciseKey(initExerciseKey);
    }, [setExerciseKey]);
    const fetchExerciseList = (0, react_1.useCallback)(({ range }) => {
        const { fromDate = '2024-01-11', toDate = '2024-04-14' } = range;
        setIsLoading(true);
        // @ts-ignore
        fetch(`${_params_1.apiHost}/charts/completed_exercises?date_start=${fromDate}&date_end=${toDate}&user=${userId}`, {
            method: "GET",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": js_cookie_1.default.get("csrftoken")
            }
        }).then(response => response.json())
            .then(response => {
            setIsLoading(false);
            setExerciseList(response);
            if (response === null || response === void 0 ? void 0 : response[0])
                setExerciseKey(response[0].slug);
            else {
                setExerciseKey(null);
                setTargets(targetsInitState);
            }
        });
    }, [setExerciseList]);
    const fetchTargetChart = (0, react_1.useCallback)(({ range, exerciseKey }) => {
        const { fromDate = '2024-01-11', toDate = '2024-04-14' } = range;
        setDataLoading(true);
        // @ts-ignore
        fetch(`${_params_1.apiHost}/charts/target/?date_start=${fromDate}&date_end=${toDate}&exercise_slug=${exerciseKey}&user=${userId}`, {
            method: "GET",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": js_cookie_1.default.get("csrftoken")
            }
        }).then(response => response.json())
            .then(response => {
            setDataLoading(false);
            setTargets(response);
        });
    }, [setTargets]);
    return {
        targets,
        fetchTargetChart,
        exerciseList,
        fetchExerciseList,
        isLoading,
        exerciseKey,
        selectExercise,
        isDataLoading,
        resetExerciseKey
    };
};
exports.useTargetChart = useTargetChart;
